import axios from "axios";

/**
 * Shared axios instance: same-origin /api, cookies included for session auth.
 *
 * paramsSerializer is set to repeat array keys (`label=a&label=b`) rather than
 * axios's default `label[]=a&label[]=b` — the server's query parser (§13)
 * expects the former, matching Fastify's default querystring parsing.
 */
export const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
  paramsSerializer: {
    serialize: (params: Record<string, unknown>) => {
      const search = new URLSearchParams();
      for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null) continue;
        if (Array.isArray(value)) {
          for (const v of value) search.append(key, String(v));
        } else {
          search.append(key, String(value));
        }
      }
      return search.toString();
    },
  },
});

export interface ApiErrorBody {
  error: string;
}

/** Best-effort extraction of the server's `{ error }` message from a failed request. */
export function apiErrorMessage(err: unknown, fallback = "Something went wrong"): string {
  if (axios.isAxiosError(err)) {
    const body = err.response?.data as ApiErrorBody | undefined;
    if (body?.error) return body.error;
  }
  return fallback;
}
